import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	emptyStateText: {
		id: 'project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.empty-state-text',
		defaultMessage: 'Add forms for customers to fill out when raising a request.',
		description: 'Message for when there is no form to display',
	},
	formsFieldName: {
		id: 'project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.forms-field-name',
		defaultMessage: 'Forms',
		description: 'Forms field name label',
	},
	formIconAriaLabel: {
		id: 'project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.form-icon-aria-label',
		defaultMessage: 'Form',
		description: 'Aria label for form icon -- displayed on the form card in request type config',
	},
	learnMoreLink: {
		id: 'project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.learn-more-link',
		defaultMessage: 'Learn more about forms.',
		description: 'Link to learn more about forms',
	},
	linkedFieldError: {
		id: 'project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.linked-field-error',
		defaultMessage: 'Linked field error.',
		description: 'A message indicating a misconfiguration of a request type form',
	},
	fixInFormBuilderLabel: {
		id: 'project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.fix-in-form-builder-label',
		defaultMessage: 'Fix in form builder',
		description: 'A message with a link to the form builder to edit a request type form',
	},
	editDropdownItemLabel: {
		id: 'project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.meatball.edit-dropdown-item-label',
		defaultMessage: 'Edit',
		description: 'Edit label displayed on the more meatball dropdown item',
	},
	opensInAnotherWindowAriaLabel: {
		id: 'project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.meatball.opens-in-another-window-aria-label',
		defaultMessage: 'Opens in another window',
		description:
			'Aria label attached to the icon informing user that the edit dropdown item will open in another window',
	},
	removeFormLabel: {
		id: 'project-settings-apps-issue-type-page-product-features.common.jsm-classic-customer-view.main-content.field-category.form-card.meatball.remove-dropdown-item-label',
		defaultMessage: 'Remove',
		description: 'Remove label displayed on the more meatball dropdown item',
	},
	fixInFormBuilderLabelNew: {
		id: 'project-settings-product-features-jsm-common.form-card.fix-in-form-builder-label-new',
		defaultMessage: 'Check linked field configuration',
		description: 'A message with a link to the form builder to edit a request type form',
	},
	conditionalFieldMismatchTooltipError: {
		id: 'project-settings-product-features-jsm-common.form-card.conditional-field-mismatch-tooltip-error',
		defaultMessage: 'Remove required fields from sections',
		description:
			'An error message displayed within the error tooltip when there are conditional fields mismatch',
	},
	requiredFieldMismatchTooltipError: {
		id: 'project-settings-product-features-jsm-common.form-card.required-field-mismatch-tooltip-error',
		defaultMessage: 'Mark linked fields as required',
		description:
			'An error message displayed within the error tooltip when there are required fields mismatch',
	},
	conditionalAndRequiredFieldMismatchTooltipError: {
		id: 'project-settings-product-features-jsm-common.form-card.conditional-and-required-field-mismatch-tooltip-error',
		defaultMessage: 'Mark linked fields as required and remove from sections',
		description:
			'An error message displayed within the error tooltip when there are conditional and required fields mismatch at the same time',
	},
	conditionalFieldMismatchSectionError: {
		id: 'project-settings-product-features-jsm-common.form-card.conditional-field-mismatch-section-error',
		defaultMessage:
			'Select <b>Edit</b> to remove the form {fieldListCount, plural, one {field linked to the required Jira field} other {fields linked to the required Jira fields}} {fieldList} from any conditional sections.',
		description:
			'An error message displayed within section above form preview when there are conditional fields mismatch',
	},
	requiredFieldMismatchSectionError: {
		id: 'project-settings-product-features-jsm-common.form-card.required-field-mismatch-section-error',
		defaultMessage:
			'Select <b>Edit</b> to mark the form {fieldListCount, plural, one {field as required to match its linked Jira field} other {fields as required to match its linked Jira fields}} {fieldList}.',
		description:
			'An error message displayed within section above form preview when there are required fields mismatch',
	},
	conditionalAndRequiredFieldMismatchSectionError: {
		id: 'project-settings-product-features-jsm-common.form-card.conditional-and-required-field-mismatch-section-error',
		defaultMessage:
			'Select <b>Edit</b> to mark the form {fieldListCount, plural, one {field} other {fields}} linked to {fieldList} as required, and remove any required linked form fields from conditional sections.',
		description:
			'An error message displayed within section above form preview when there are conditional and required fields mismatch at the same time',
	},
	fieldMismatchErrorIcon: {
		id: 'project-settings.issue-type-page-product-features-jsm-common.ui.form-panel.form-card.field-mismatch-error-icon',
		defaultMessage: 'Field mismatch error icon.',
		description:
			'An error icon displayed within section above form preview when there are fields mismatch',
	},
});
